import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'paceUrl',
    standalone: false,
})
export class PaceUrlPipe implements PipeTransform {
    public transform(value: string): string {
        if (!value) {
            return '';
        }

        const urlStartTag = '[url]';
        const urlEndTag = '[/url]';

        if (value.includes(urlStartTag) && value.includes(urlEndTag)) {
            const [prefix, urlWithSuffix] = value.split('[url]');
            const [url, suffix = ''] = urlWithSuffix.split('[/url]');
            const link = `<a href="${url}" paceCoreLink class="pace-link" target="_blank">${url}</a>`;
            return `${prefix}${link}${suffix}`;
        }
        return value.replace(urlStartTag, '').replace(urlEndTag, '');
    }
}
